import type { ReactNode, ComponentType } from "react";

interface LegalPageShellProps {
  icon: ComponentType<{ className?: string }>;
  title: string;
  subtitle: string;
  lastUpdated: string;
  children: ReactNode;
}

/** Shared layout chrome for the Terms / Privacy / Disclaimer pages. */
export const LegalPageShell = ({
  icon: Icon,
  title,
  subtitle,
  lastUpdated,
  children,
}: LegalPageShellProps) => (
  <article>
    <header className="mb-8">
      <div className="flex items-center gap-3 mb-2">
        <Icon className="w-6 h-6 text-primary" />
        <h1 className="text-3xl font-bold tracking-tight">{title}</h1>
      </div>
      <p className="text-muted-foreground">{subtitle}</p>
      <p className="text-xs text-muted-foreground mt-2">Last updated: {lastUpdated}</p>
    </header>
    {children}
  </article>
);

export const LegalSection = ({ title, children }: { title: string; children: ReactNode }) => (
  <section className="mb-7">
    <h2 className="text-lg font-semibold mb-2">{title}</h2>
    <div className="space-y-3 text-sm text-muted-foreground leading-relaxed [&_strong]:text-foreground">
      {children}
    </div>
  </section>
);

export default LegalPageShell;
